import { Component } from '@angular/core';
import { LoginFormComponent } from './login-form/login-form.component';
import { LoginWelcomeComponent } from './login-welcome/login-welcome.component';

@Component({
    selector: 'r1-appcloud-login',
    template: `
        <div class="login-background">
            <div class="flex-container">
                <r1-login-form />
                <r1-login-welcome />
            </div>
        </div>
    `,
    styleUrls: ['./appcloud-login.component.scss'],
    imports: [LoginFormComponent, LoginWelcomeComponent],
})
export class AppCloudLoginComponent {}
